import { render, staticRenderFns } from "./ReviewViewPage.vue?vue&type=template&id=1167e705&scoped=true&"
import script from "./ReviewViewPage.vue?vue&type=script&lang=js&"
export * from "./ReviewViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1167e705",
  null
  
)

export default component.exports